import { useTexts } from './useTexts'
import { form } from '../../formState'

export function Email() {
  const texts = useTexts()

  return <form.TextField name="email" testId="email" label={texts.email} validateOn="blur change" />
}
